import type { ReactNode } from "react";
import { Button, GridListItem, type GridListItemProps, type GridListItemRenderProps } from "react-aria-components";

import { Checkbox } from "../Checkbox/Checkbox.tsx";
import { SymbolIcon } from "../Icon/SymbolIcon.tsx";
import { HStack } from "../Stack/HStack.tsx";

interface ReorderableListItemProps extends Omit<GridListItemProps, "children"> {
  id: string;
  hideDragHandle?: boolean;
  children: ReactNode | ((renderProps: GridListItemRenderProps) => ReactNode);
}

export function ReorderableListItem({ id, children, hideDragHandle, ...props }: ReorderableListItemProps) {
  return (
    <GridListItem id={id} {...props}>
      {(renderProps) => (
        <HStack>
          {/* Add elements for drag and drop and selection. */}
          {renderProps.allowsDragging && hideDragHandle !== true && (
            <Button slot="drag" style={{ all: "unset", height: 20, lineHeight: "20px" }}>
              <SymbolIcon icon="drag_indicator" />
            </Button>
          )}
          {renderProps.selectionMode === "multiple" && renderProps.selectionBehavior === "toggle" && (
            <Checkbox slot="selection" />
          )}
          {typeof children === "function" ? children(renderProps) : children}
        </HStack>
      )}
    </GridListItem>
  );
}
